import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { UserService } from './user.service';

@Injectable()
export class HttpClientService {

    constructor(
      private http: Http,
      private _userService: UserService
    ) { }

    createBaseHeader(headers: Headers) {
      if(headers == null){
        headers = new Headers();
      }
      headers.set('x-access-token', this._userService.getToken());
      return headers;
    }

    get(url, headers?: Headers) {
      headers = this.createBaseHeader(headers);
      return this.http.get(url, {
        headers: headers
      });
    }

    post(url, data, headers?: Headers, options?: RequestOptions) {
      headers = this.createBaseHeader(headers);
      return this.http.post(url, data, {
        headers: headers
      });
    }

    put(url, data, headers?: Headers) {
      headers = this.createBaseHeader(headers);
      return this.http.put(url, data, {
        headers: headers
      });
    }

    delete(url, headers?: Headers) {
      headers = this.createBaseHeader(headers);
      return this.http.delete(url, {
        headers: headers
      });
    }

    postMedia(url, data, options?: RequestOptions) {
      options.headers = this.createBaseHeader(options.headers);
      return this.http.post(url, data, options);
    }

    deleteMedia(url, options?: RequestOptions) {
      options.headers = this.createBaseHeader(options.headers);
      return this.http.delete(url, options);
    }

    getMedia(url, options?: RequestOptions) {
      options.headers = this.createBaseHeader(options.headers);
      return this.http.get(url, options);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/http.client.service.ts